export function getBrowserTimeZone(): string {
	try {
		return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
	} catch {
		return 'UTC';
	}
}

export function getIsoWeekKey(date: Date, timeZone: string): string {
	try {
		return getIsoWeekKeyForTimeZone(date, timeZone);
	} catch {
		return getIsoWeekKeyForTimeZone(date, 'UTC');
	}
}

function getIsoWeekKeyForTimeZone(date: Date, timeZone: string): string {
	const dateParts = new Intl.DateTimeFormat('en-US', {
		timeZone,
		year: 'numeric',
		month: '2-digit',
		day: '2-digit',
	}).formatToParts(date);
	let year = 0;
	let month = 0;
	let day = 0;
	for (const part of dateParts) {
		if (part.type === 'year') {
			year = Number(part.value);
		} else if (part.type === 'month') {
			month = Number(part.value);
		} else if (part.type === 'day') {
			day = Number(part.value);
		}
	}
	const localDate = new Date(Date.UTC(year, month - 1, day));
	const isoDay = localDate.getUTCDay() || 7;
	localDate.setUTCDate(localDate.getUTCDate() + 4 - isoDay);

	const isoYear = localDate.getUTCFullYear();
	const firstDayOfIsoYear = new Date(Date.UTC(isoYear, 0, 1));
	const week = Math.ceil(
		((localDate.getTime() - firstDayOfIsoYear.getTime()) / 86_400_000 + 1) / 7,
	);

	return `${isoYear}-W${String(week).padStart(2, '0')}`;
}
